<div class="forecast-legend">
  <div class="forecast-legend__header">
    <span class="forecast-legend__title">Legend</span>
  </div>
  <div class="forecast-legend__items">
    <div class="forecast-legend__item">
      <span class="forecast-legend__swatch forecast-legend__swatch--final"></span>
      <span class="forecast-legend__label">Final emissions</span>
    </div>
    <div class="forecast-legend__item">
      <span class="forecast-legend__swatch forecast-legend__swatch--projected"></span>
      <span class="forecast-legend__label">Projected emissions</span>
    </div>

    <div class="forecast-legend__item">
      <span class="forecast-legend__line forecast-legend__line--baseline"></span>
      <span class="forecast-legend__label">Baseline emissions</span>
    </div>
    <div class="forecast-legend__item">
      <span class="forecast-legend__swatch forecast-legend__swatch--bau"></span>
      <span class="forecast-legend__label">Emissions business as usual + growth</span>
    </div>
    <div class="forecast-legend__item">
      <span class="forecast-legend__line forecast-legend__line--bau-trend"></span>
      <span class="forecast-legend__label">Business as usual + growth</span>
    </div>
  </div>
</div>
